import styled from "styled-components";
import { Button } from "../Button/Button.js";
import { ButtonSize } from "../Button/Button.types.js";
import { ITheme } from "../Theme/Theme.types.js";
import { IconButtonProps } from "./IconButton.types.js";

const paddingMap = (theme: ITheme): Record<ButtonSize, string> => ({
    large: theme.spacing[16],
    medium: theme.spacing[12],
    small: theme.spacing[8],
});

export const StyledIconButton = styled(Button)<Omit<IconButtonProps, "icon">>`
    padding: ${(props) => paddingMap(props.theme)[props.size ?? "medium"]};
    height: fit-content;
    border-radius: ${(props) => props.rounded && props.theme.radius.round};
    transition-property: box-shadow, border-color, color, background-color;

    span {
        display: flex;
    }
`;
